import type {
  CurrentGuest,
  GuestsInterest,
  GuestsTypology,
  SpaceFiltersValues,
  SpaceEntity,
  Tag,
} from "modules/spaces/domain/space/space.types";

export const generateGuestsArray = (
  currentGuests?: number,
  maxGuests?: number,
) => {
  if (typeof currentGuests === "number" && typeof maxGuests === "number") {
    return Array.from(Array(maxGuests).keys()).map((el) => ({
      key: el,
      isOccupied: el < currentGuests,
    }));
  }
  return [];
};

const isFirstGuest = (space: SpaceEntity, tags: Tag[]) => {
  if (space?.currentGuests?.length === 0) {
    tags?.push({
      label: "firstGuest",
      iconName: "user",
    });
  }
};

const isRecommended = (tags: Tag[], isFirstSpace?: boolean) => {
  if (isFirstSpace) {
    tags?.push({
      label: "recommended",
      iconName: "sparkles",
    });
  }
};

export const generateTags = (
  space: SpaceEntity,
  isFirstSpace?: boolean,
): Tag[] => {
  const elaboratedTags: Tag[] = [...(space?.tags ?? [])];

  isRecommended(elaboratedTags, isFirstSpace);
  isFirstGuest(space, elaboratedTags);

  return elaboratedTags;
};

export const getGuestsByTypology = (
  guests: CurrentGuest[],
): GuestsTypology[] => {
  const guestsByTypology = guests.reduce(
    (acc: { [key: string]: number }, guest) => {
      if (acc[guest.type]) {
        return { ...acc, [guest.type]: acc[guest.type] + 1 };
      }
      return { ...acc, [guest.type]: 1 };
    },
    {},
  );
  return Object.keys(guestsByTypology).map((guest) => ({
    type: guest,
    count: guestsByTypology[guest],
  }));
};

export const getGuestsByInterests = (
  guests: CurrentGuest[],
): GuestsInterest[] => {
  const guestsByInterests = guests.reduce(
    (globalAcc: { [key: string]: number }, value) => {
      return {
        ...globalAcc,
        ...value.interests.reduce(
          (acc: { [key: string]: number }, interest) => {
            return {
              ...acc,
              [interest]: globalAcc[interest] ? globalAcc[interest] + 1 : 1,
            };
          },
          {},
        ),
      };
    },
    {},
  );
  return Object.keys(guestsByInterests).map((guest) => ({
    count: guestsByInterests[guest],
    interest: guest,
  }));
};

export const getAccordionPanels = (
  space: SpaceEntity | null,
): { [key: string]: string[] } | null => {
  if (space) {
    const spacesPanels = {
      features: space.features,
      accessibility: space.accessibility,
      rules: space.rules,
      "building-services": space.buildingServices,
    };
    return spacesPanels;
  }
  return null;
};

export const cleanFromEmptiesFilters = (filters: SpaceFiltersValues) => {
  return Object.keys(filters).reduce<SpaceFiltersValues>((accumulator, key) => {
    if (filters[key].length) {
      accumulator[key] = filters[key];
    }
    return accumulator;
  }, {});
};
